import React from 'react'
import queryString from 'query-string'
import { withRouter } from 'react-router-dom'
import { clearSession } from '../../lib/utils'
import { get } from '../../lib/storage'
// class Logout extends Component {
//   constructor (props) {
//     super(props)
//     const { history } = props
//     const { redirect_to } =  queryString.parse(props?.location?.state?.from?.search)
//     clearSession()
//     redirect_to ? history.push(`/login?redirect_to=${redirect_to}`) : history.push('/login')
//   }

//   render () {
//     return null
//   }
// }

function Logout(props) {
  const { history } = props
  const { redirect_to } = queryString.parse(
    props?.location?.state?.from?.search
  )
  let ugc = get('ugc')
  if (ugc) {
    let uid = get('uid')
    let token = get('token')
    console.log(uid, token)
    clearSession()
    if (window.Android) {
      if (window.Android.onWriterLogout) {
        console.log('Executed onWriterLogout')
        window.Android.onWriterLogout(uid, token)
      }
    } else {
      console.log('Function onWriterLogout not exist')
    }
    if (window.webkit) {
      if (window.webkit.messageHandlers) {
        console.log('messageHandlers webkit.onWriterLogout')
        window.webkit.messageHandlers.onWriterLogout.postMessage()
      }
    }
    history.push(
      // `/onboarding?redirect_to=${redirect_to}&flow=ugc&uid=${uid}&token=${token}`
      `/globalLogin?redirect_to=${redirect_to}`
    )
  } else {
    clearSession()
    redirect_to
      ? history.push(`/login?redirect_to=${redirect_to}`)
      : history.push('/login')
  }

  return <></>
}

export default withRouter(Logout)
